import { langs } from "./navigator";

// 获取浏览器本地语言
export const getLng = () => {
  if (process.env.REACT_APP_IDN) {
    switch (langs) {
      case "zh-TW":
        return "zh";
      case "zh-CN":
        return "zh_CN";
      case "en":
      case "ja":
      case "ko":
      case "vi":
      case "de":
      case "es":
      case "fr":
      case "pt":
      case "tr":
      case "ar":
      case "ru":
        return langs;
      default:
        return "en";
    }
  }
  return "en";
};

// 传给服务端接口
export const getLngToApi = () => {
  if (process.env.REACT_APP_IDN) {
    return langs;
  }
  return "en";
};
